import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework';
import { RadnoMesto } from './radno-mesto';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-radno-mesto-update',
  templateUrl: './radno-mesto-update.component.html'
})
export class RadnoMestoUpdateComponent 
  extends BaseUpdateComponent<RadnoMesto> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService)
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'RADNOMESTO.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(100), 'maxlength', 'RADNOMESTO.NAZIV.VALIDATION.MAXLENGTH');
  }

}
